export class YesNoOptions {
  static readonly Yes = { displayValue: 'Yes', value: true };
  static readonly No = { displayValue: 'No', value: false };

  static readonly ALL = [YesNoOptions.Yes, YesNoOptions.No];
}
